import { useQuery } from '@tanstack/react-query'
import { postNamedQuery } from '../../../../../service'

export const useListReportObjects = (body = {}, options = {}) => {
  const { mapper = null, enabled = true } = options ?? {}
  return useQuery({
    queryKey: ['reports', 'listReportObjects', body],
    queryFn: async () => {
      const result = await postNamedQuery('reports', 'list-report-objects', {
        skip: 0,
        take: 99999,
        orderBy: 'name',
        ...body
      })

      return result.data
    },
    mapper: mapper ?? ((data) => data?.data ?? []),
    enabled
  })
}
